module.exports = __webpack_public_path__ + "img/tool_grid.1ea9a0db.png";